/**
 * 设备检测插件
 * 在 Vue 实例上挂载全局设备检测方法和响应式属性
 */
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { 
  isMobile as checkIsMobile, 
  isTablet as checkIsTablet, 
  isDesktop as checkIsDesktop, 
  getDeviceType,
  getViewportWidth,
  getViewportHeight
} from '@/utils/viewport'

// 防抖函数
function debounce(fn, delay = 150) {
  let timer = null
  return function(...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

// 创建全局响应式设备状态
const deviceWidth = ref(0)
const deviceHeight = ref(0)
const deviceType = ref('desktop')

// 更新设备信息
function updateDeviceInfo() {
  if (typeof window !== 'undefined') {
    deviceWidth.value = getViewportWidth()
    deviceHeight.value = getViewportHeight()
    deviceType.value = getDeviceType()
  }
}

// 创建防抖的更新函数
const debouncedUpdate = debounce(updateDeviceInfo, 150)

// 初始化
if (typeof window !== 'undefined') {
  updateDeviceInfo()
  window.addEventListener('resize', debouncedUpdate, { passive: true })
  window.addEventListener('orientationchange', debouncedUpdate)
}

// 导出 composable
export function useDevice() {
  onMounted(() => {
    // 模块加载时已注册全局监听，此处只需刷新一次确保数据最新，无需重复注册
    updateDeviceInfo()
  })

  onBeforeUnmount(() => {
    // 全局监听由模块级代码统一管理，此处无需移除
  })

  return {
    deviceWidth: computed(() => deviceWidth.value),
    deviceHeight: computed(() => deviceHeight.value),
    deviceType: computed(() => deviceType.value),
    // 关键修复：基于 deviceWidth 建立响应式依赖
    isMobile: computed(() => {
      const _ = deviceWidth.value
      return checkIsMobile()
    }),
    isTablet: computed(() => {
      const _ = deviceWidth.value
      return checkIsTablet()
    }),
    isDesktop: computed(() => {
      const _ = deviceWidth.value
      return checkIsDesktop()
    })
  }
}

// Vue 插件
export default {
  install(app) {
    // 挂载到全局属性
    app.config.globalProperties.$device = {
      get width() {
        return deviceWidth.value
      },
      get height() {
        return deviceHeight.value
      },
      get type() {
        return deviceType.value
      },
      get isMobile() {
        // 关键修复：基于 deviceWidth 建立响应式依赖
        const _ = deviceWidth.value
        return checkIsMobile()
      },
      get isTablet() {
        const _ = deviceWidth.value
        return checkIsTablet()
      },
      get isDesktop() {
        const _ = deviceWidth.value
        return checkIsDesktop()
      }
    }

    // 提供全局方法
    app.provide('device', {
      deviceWidth,
      deviceHeight,
      deviceType,
      // 关键修复：基于 deviceWidth 建立响应式依赖
      isMobile: computed(() => {
        const _ = deviceWidth.value
        return checkIsMobile()
      }),
      isTablet: computed(() => {
        const _ = deviceWidth.value
        return checkIsTablet()
      }),
      isDesktop: computed(() => {
        const _ = deviceWidth.value
        return checkIsDesktop()
      })
    })

    console.log('[Device Plugin] 设备检测插件已安装')
  }
}


